import { combineReducers } from 'redux';
import {
  REQUEST_USER_DATA,
  RECEIVE_USER_DATA,
  REQUEST_TOKEN,
  RECEIVE_TOKEN,
  DROP_TOKEN,
  RECEIVE_MOBILE_OTP,
  REQUEST_MOBILE_OTP,
  SET_AUTH_SCREEN, RECEIVE_RESET_PWD_OTP, REQUEST_RESET_PWD_OTP, SET_EMAIL, SET_PHONE_NUMBER, CLEAR_EMAIL, CLEAR_PHONE_NUMBER
} from './actions';


const initialState = {
    phone: "",
    email: ""
}

const authMode = (state = {}, action = {}) => {
  switch (action.type) {
    case SET_AUTH_SCREEN:
      return {...state, mode: action.screenCode};
    case RECEIVE_MOBILE_OTP:
      return {mode: action.screenCode, data: action.data};
    case RECEIVE_RESET_PWD_OTP:
      return {mode: action.screenCode, data: action.data};
    default:
      return state;
  }
};

const isAuthFetching = (state = false, action = {}) => {
  switch (action.type) {
    case REQUEST_MOBILE_OTP:
    case REQUEST_RESET_PWD_OTP:
    case REQUEST_USER_DATA:
    case REQUEST_TOKEN:
      return true;
    case RECEIVE_MOBILE_OTP:
    case RECEIVE_USER_DATA:
    case RECEIVE_TOKEN:
    case RECEIVE_RESET_PWD_OTP:
    case DROP_TOKEN:
      return false;
    default:
      return state;
  }
};

const data = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_PHONE_NUMBER:
      return {
        ...state,
        phone: action.phone,
      };
    case CLEAR_PHONE_NUMBER:
      return {
        ...state,
        phone: "",
      };
    case CLEAR_EMAIL:
      return {
        ...state,
        email: "",
      };
    case SET_EMAIL:
      return {
        ...state,
        email: action.email,
      };
    default:
      return state;
  }
};

const userData = (state = {}, action = {}) => {
  switch (action.type) {
    case REQUEST_USER_DATA:
      return state;
    case RECEIVE_USER_DATA:
      if (action.data.code)
        return state;
      else
        return action.data;
    default:
      return state;
  }
};

const isUserDataFetching = (state = false, action = {}) => {
  switch (action.type) {
    case REQUEST_USER_DATA:
      return action.query ?? true;
    case RECEIVE_USER_DATA:
      return false;
    default:
      return state;
  }
};

const userToken = (state = [], action = {}) => {
  switch (action.type) {
    case REQUEST_TOKEN:
      return state;
    case DROP_TOKEN:
    case RECEIVE_TOKEN:
      return action.data;
    default:
      return state;
  }
};

const isUserTokenFetching = (state = false, action = {}) => {
  switch (action.type) {
    case REQUEST_TOKEN:
      return true;
    case RECEIVE_TOKEN:
    case DROP_TOKEN:
      return false;
    default:
      return state;
  }
};

const formInitialState = {
  formData: {
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    phone_country: "RU",
    password: "",
    login: ""
  },
  errors: {}
};

const registrationForm = (state = formInitialState, action) => {
  switch (action.type) {
    case 'SET_FORM_DATA': {
      return {
        ...state,
        formData: { ...state.formData, ...action.payload }
      };
    }

    case 'SET_FORM_ERROR': {
      const { field, error } = action.payload;
      return {
        ...state,
        errors: {
          ...state.errors,
          [field]: error
        }
      };
    }

    case 'RESET_FORM': {
      return formInitialState;
    }

    default:
      return state;
  }
};

export const getAuthFetching = (state) => state.isAuthFetching;
export const getAuthMode = (state) => state.authMode;
export const getUserData = (state) => state.userData;
export const getData = (state) => state.data;
export const getAuthToken = (state) => state.userToken.token;
export const getUserFetching = (state) => state.isUserTokenFetching || Boolean(state.isUserDataFetching);
export const getUserUpdatingQuery = (state) => typeof state.isUserDataFetching === 'string' ? state.isUserDataFetching : '';
export const getUserLoggedIn = (state) => state.userToken.loggedIn;
export const getUserLoginError = (state) => (state.userToken.message ? state.userToken.message : '');
export const getUserDisplayName = (state) => state.userToken.userDisplayName;
export const getRegistrationFormData = (state) => state.registrationForm.formData;
export const getRegistrationFormErrors = (state) => state.registrationForm.errors;

const userLogin = combineReducers({
  userData,
  isUserDataFetching,
  userToken,
  isUserTokenFetching,
  authMode,
  isAuthFetching,
  data,
  registrationForm
});

export default userLogin;
